import { render, staticRenderFns } from "./MeetingRecords.vue?vue&type=template&id=80d2e524&scoped=true&"
import script from "./MeetingRecords.vue?vue&type=script&lang=js&"
export * from "./MeetingRecords.vue?vue&type=script&lang=js&"
import style0 from "./MeetingRecords.vue?vue&type=style&index=0&id=80d2e524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d2e524",
  null
  
)

export default component.exports